import type { Suggestion } from '@rp/contracts'
import { SUGGESTION_COPY } from './copy'

type FailureFacts = Pick<Suggestion, 'status' | 'error'>

const BUDGET_EXHAUSTED_ERROR = 'budget_exhausted'

const isBudgetRefusal = ({ status, error }: FailureFacts): boolean =>
  status === 'failed' && error === BUDGET_EXHAUSTED_ERROR

export const stateLabelOf = (suggestion: FailureFacts): string =>
  isBudgetRefusal(suggestion) ? SUGGESTION_COPY.budgetExhaustedState : SUGGESTION_COPY.states[suggestion.status]

export const failureHintOf = (suggestion: FailureFacts): string =>
  isBudgetRefusal(suggestion) ? SUGGESTION_COPY.budgetExhaustedHint : SUGGESTION_COPY.failedHint
